import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { Form } from '@unform/web';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { FormHandles } from '@unform/core';
import { format, parseISO, subDays } from 'date-fns';
import Select, { IOption } from '~/components/Select';
import api from '~/services/api';
import { Entries } from './styles';
import formatDate from '~/utils/formatDate';

interface IDailySale {
  date: string;
  organizer_id: number;
  organizer_name: string;
  total: string;
  total_orders: string;
  quantity_tickets: string;
  tickets_cancelled: string;
  total_organizer: string;
  total_discount: string;
  total_koro: string;
  total_gateway: string;
  value_cancelled: string;
  value_refunded: string;
}

interface ISaleDay {
  day: string;
  value: number;
}

interface IEntriesCardProps {
  lineChart: number;
  selectedEventId?: number | null;
}

const lastSalesOptions: IOption[] = [
  { id: 1, value: 'Hoje', selected: false },
  { id: 2, value: 'Últimos 7 dias', selected: false },
  { id: 3, value: 'Últimos 15 dias', selected: true },
  { id: 4, value: 'Últimos 30 dias', selected: false },
];

const daysMap: Record<number, number> = { 1: 1, 2: 7, 3: 15, 4: 30 };

const EntriesCard: React.FC<IEntriesCardProps> = ({
  lineChart,
  selectedEventId,
}) => {
  const formRef = useRef<FormHandles>(null);
  const [salesDay, setSalesDay] = useState<ISaleDay[]>([]);
  const [idDate, setIdDate] = useState<number>(3);

  const loadSales = useCallback(
    (eventId?: number | null) => {
      const url =
        eventId && eventId !== 0
          ? `/sales/organizers/daily/event/${eventId}`
          : '/sales/organizers/daily';

      api
        .get<IDailySale[]>(url, {
          params: { days: daysMap[idDate] ?? 15, isHome: true },
        })
        .then((response) => {
          const daysCount = daysMap[idDate] ?? 15;

          const apiData: ISaleDay[] = response.data.map((item) => ({
            day: formatDate(parseISO(item.date), 'dd/MM'),
            value: parseInt(item.quantity_tickets, 10) || 0,
          }));

          const allDays: ISaleDay[] = [];
          for (let i = daysCount - 1; i >= 0; i -= 1) {
            const day = formatDate(subDays(new Date(), i), 'dd/MM');
            const found = apiData.find((s) => s.day === day);
            allDays.push({ day, value: found?.value || 0 });
          }

          setSalesDay(allDays);
        });
    },
    [idDate]
  );

  useEffect(() => {
    loadSales(selectedEventId);
  }, [selectedEventId, loadSales]);

  const seriesEntries = useMemo(
    () => [{ name: 'Inscrições', data: salesDay.map((s) => s.value) }],
    [salesDay]
  );

  console.log(salesDay);

  const optionsEntries = useMemo<ApexOptions>(
    () => ({
      chart: {
        height: 350,
        type: 'bar',
        zoom: { enabled: false },
        toolbar: { show: false },
      },
      colors: ['#ff6900'],
      dataLabels: { enabled: false },
      yaxis: {
        min: 0,
        labels: {
          formatter: (value) =>
            Number.isInteger(value) ? value.toString() : '',
        },
      },
      xaxis: {
        categories: salesDay.map((s) => s.day),
      },
    }),
    [salesDay]
  );

  return (
    <Entries className="col-12 bg-white mt-3">
      <Form ref={formRef} onSubmit={() => undefined}>
        <div className="zoom px-4 py-3 d-flex align-items-center justify-content-between">
          <h2 className="h3 fw-semibold">Inscrições nos ultimos dias</h2>
          <div className="d-flex align-items-center">
            <Select
              name="lastSales"
              className="sold-input"
              options={lastSalesOptions}
              onChange={(e) => setIdDate(Number((e as unknown as IOption).id))}
            />
          </div>
        </div>
        <div>
          <ReactApexChart
            options={optionsEntries}
            series={seriesEntries}
            type="bar"
            height={lineChart}
          />
        </div>
      </Form>
    </Entries>
  );
};

export default EntriesCard;
